import { useParams } from 'react-router-dom'

export const useStrictParams = <Params extends string>(): { [Key in Params]: string } => {
  const params = useParams()
  for (const paramName in params) {
    if (paramName !== '*' && !params[paramName]) {
      throw new Error(`Missing param ${paramName}`)
    }
  }
  return params as { [Key in Params]: string }
}
